
<div class="modal-header">
    <span class="modal-header-title"> Основные данные </span>
    <!-- <span *ngIf="attrId" class="modal-header-title">{{ 'DIALOG.ATTRIBUTE.EDIT_ATTRIBUTE' | translate }}</span> -->
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>

<div class="modal-body">

    <!-- form -->
    <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">
        <div class="row">

            <!-- name lang -->
            <div class="col-8">  
                <ff-input-lang
                    label="Название"
                    fieldId="name"
                    fieldName="name"
                    fieldType="text"
                    [clearField]="ffInputLangParams.name.clearField"
                    [required]="ffInputLangParams.name.required"
                    [inputValue]="attributeName" 
                    (changeValue)="eventFnFF('name', $event.name)">
                </ff-input-lang>
            </div>

            <!-- attribute_group_id -->
            <div class="col-4 input">
                <div class="form-group test row">

                    <div class="col-10">
                        <label for="attribute_group_id"> <span class="star">*</span>  Группа </label>
                        <ng-select  
                            class="custom"
                            placeholder="Выберите значение" 
                            clearAllText="{{ 'CLEAN' | translate }}"
                            notFoundText="{{ 'NO_DATA' | translate }}"
                            bindLabel="name"
                            bindValue="id"
                            formControlName="attribute_group_id"
                            [loading]="loading"
                            [items]="attributeGroups">
                            <ng-template ng-option-tmp let-item="item">
                                <div title="{{ item.name }}"> {{ item.name }} </div>
                            </ng-template>
                        </ng-select>
                        <!-- errorMessages -->
                        <div *ngIf="errorMessages">
                            <div *ngFor="let item of errorMessages.attribute_group_id">
                                <div class="text-error" *ngIf="validation('attribute_group_id', item.type)">
                                    {{ item.message | translate: item.options }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-1">
                        <!-- btn add -->
                        <button type="button" [disabled]="attrEditable" class="btn btn-add btn-sm" (click)="attributesGroups()"> 
                            <span class="icon"> <i class="bi bi-plus-circle"></i> </span>
                        </button>
                    </div>

                </div>
            </div>

        </div>

        <div class="row bottom-form">

            <!-- attr_present_type_id -->
            <div [ngClass]="{'col-6': !referenceControl, 'col-4': referenceControl}">
                <div class="form-group" class="label">
                    <label for="attr_present_type_id"> <span class="star">*</span>  Формат </label>
                    <ng-select  
                        class="custom"
                        placeholder="Выберите значение" 
                        clearAllText="{{ 'CLEAN' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="translate"
                        bindValue="id"
                        formControlName="attr_present_type_id"
                        [loading]="loading"
                        [items]="attributePresentationTypes"
                        [readonly]="attrEditable">
                        <ng-template ng-option-tmp let-item="item">
                            <div title="{{ item.translate }}"> {{ item.translate }} </div>
                        </ng-template>
                    </ng-select>
                    <!-- errorMessages -->
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.attr_present_type_id">
                            <div class="text-error" *ngIf="validation('attr_present_type_id', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- attribute_value_type -->
            <div [ngClass]="{'col-6': !referenceControl, 'col-4': referenceControl}">
                <div class="form-group" class="label">
                    <label for="attribute_value_type"> <span class="star">*</span> Тип </label>
                    <ng-select  
                        [readonly]="attrEditable"
                        class="custom"
                        placeholder="Выберите значение" 
                        clearAllText="{{ 'CLEAN' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="translate"
                        bindValue="id"
                        formControlName="attribute_value_type"
                        [loading]="loading"
                        [items]="attributeValueTypes">
                        <ng-template ng-option-tmp let-item="item">
                            <div title="{{ item.translate }}"> {{ item.translate }} </div>
                        </ng-template>
                    </ng-select>
                    <!-- errorMessages -->
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.attribute_value_type">
                            <div class="text-error" *ngIf="validation('attribute_value_type', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- attr_reference_id -->
            <div class="col-4" *ngIf="referenceControl">
                <div class="form-group test">
                    <div class="row">
                        <div class="col-10">
                            <label for="attr_reference_id"> <span class="star">*</span> Справочник </label>
                            <ng-select  
                                [readonly]="attrEditable"
                                class="custom"
                                placeholder="Выберите значение" 
                                clearAllText="{{ 'CLEAN' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}"
                                bindLabel="name"
                                bindValue="id"
                                formControlName="attr_reference_id"
                                [loading]="loading"
                                [items]="getDirectory">
                            <ng-template ng-option-tmp let-item="item">
                                <div title="{{ item.name }}"> {{ item.name }}</div>
                            </ng-template>
                            </ng-select>
                            <!-- errorMessages -->
                            <!-- <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.attr_reference_id">
                                    <div class="text-error" *ngIf="validation('attr_reference_id', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div> -->
                        </div>

                        <div class="col-1">
                            <!-- btn add -->
                            <button type="button" [disabled]="attrEditable" class="btn btn-add btn-sm" (click)="referencesCreate()"> 
                                <span class="icon"> <i class="bi bi-plus-circle"></i> </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </form>
</div>

<!-- buttons -->
<div class="footer-buttons">

    <!-- btn create -->
    <div class="btn-create">

        <!-- btn create attribute -->
        <button *ngIf="!attrId"  type="button" class="btn btn-primary btn-sm" (click)="onCreate()" [disabled]="form.invalid"> 
            Сохранить и закрыть
        </button>

        <!-- btn edit attribut -->
        <button *ngIf="attrId"  type="button" class="btn btn-primary btn-sm" (click)="onUpdate()" [disabled]="form.invalid"> 
            Сохранить и закрыть
        </button>
    </div>

    <!-- check box -->
    <div class="check-box">

        <!-- multilingual -->
        <div class="multilingual">
            <input type="checkbox" class="multilingual-checkbox" (change)="multilingual($event)" [(ngModel)]="translation" [disabled]="!test || !attributeTypeControl || attrEditable">
            <label class="checkbox-label" for="select"> Мультиязычный </label>
        </div>

        <!-- required -->
        <div class="required">
            <input type="checkbox" class="required-checkbox" (change)="required($event)" [(ngModel)]="mandatory">
            <label class="checkbox-label" for="select"> Обязательный </label>
        </div>

    </div>
</div>